import {Component, Input, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {ListWithItemsCount} from '../../../../list/models/list';
import {Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {getIsFocusListCardPending} from '../../../../list/reducers/list.reducer';
import {stopFocusAvailableListCard, openList} from '../../../../list/actions/list.actions';
import {
  ApBookmarkListCardComponent
} from 'user/components/bookshelf/ap-bookmark-list-card/ap-bookmark-list-card.component';

@Component({
  selector: 'app-ap-bookmark-list',
  templateUrl: './ap-bookmark-list.component.html',
  styleUrls: ['./ap-bookmark-list.component.scss']
})
export class ApBookmarkListComponent implements OnInit, OnDestroy {
  @Input() public lists: ListWithItemsCount[];

  @ViewChildren(ApBookmarkListCardComponent) private listCards: QueryList<ApBookmarkListCardComponent>;

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly store: Store,
  ) {
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.store.select(getIsFocusListCardPending).subscribe((isFocusPending) => {
        if (isFocusPending) {
          this.store.dispatch(stopFocusAvailableListCard());
          setTimeout(() => {
            this.listCards.first.focus();
          });
        }
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public openList(list: ListWithItemsCount): void {
    this.store.dispatch(openList({listId: list.id}));
  }

  public trackById(index: number, list: ListWithItemsCount): string {
    return list.id;
  }
}
